import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import Filters from 'works/legacy/lib/filters';

type FilterValues = { [key: string]: unknown[] | unknown | undefined };

type FilterStore = {
  setFilters: (key: string, values: FilterValues) => void;
  getFilters: (key: string) => FilterValues;
};

export const localStorageStore = Filters;

export const inMemoryStore: FilterStore = {
  getFilters: () => ({}),
  setFilters: () => {},
};

export const useStoredFilters = <S extends FilterValues>(
  key: string,
  {
    defaults,
    store,
  }: {
    defaults?: SetStateAction<S>;
    store: FilterStore;
  }
) => {
  const [filters, setState] = useState<S>(() => {
    const storage = store.getFilters(key) as S;

    if (typeof defaults === 'function') {
      return defaults(storage);
    }

    // undefined spread is ok.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return { ...storage, ...defaults! };
  });

  const setFilters: Dispatch<SetStateAction<S>> = useCallback(
    (callbackOrState) => {
      setState((old) => {
        const newFilters =
          typeof callbackOrState === 'function'
            ? callbackOrState(old)
            : callbackOrState;

        store.setFilters(key, newFilters);

        return newFilters;
      });
    },
    [key, store]
  );

  return [filters, setFilters] as const;
};
